module.exports = __webpack_public_path__ + "img/depmap_svg_V69.ed25bda8.svg";